import { RISK_LEVELS } from '@silverfort-nodelibs/common/utils/consts';
import { getRiskIndicatorByRiskRule, RISK_RULES } from '@silverfort-nodelibs/common/utils/insight';

const RISK_SEVERITIES_OPTIONS = Object.values(RISK_LEVELS)
    .filter((level) => level !== RISK_LEVELS.LOW)
    .map((severity) => ({
        value: severity.value,
        title: severity.label
    }));

const RISK_INDICATORS_OPTIONS = Object.values(RISK_RULES).map((rule: string) => ({
    value: rule,
    title: getRiskIndicatorByRiskRule(rule)?.authTitle ?? rule
}));

export { RISK_SEVERITIES_OPTIONS, RISK_INDICATORS_OPTIONS };
